import type { DossierCommitment } from '../../../services/CrmDossierService';

export const COMMITMENT_STATE_LABELS: Record<string, string> = {
  scheduled: 'Programado',
  needs_you: 'Precisa de você',
  waiting_condition: 'Aguardando condição',
  done: 'Concluído',
  cancelled: 'Cancelado',
  expired: 'Expirado',
  failed: 'Falhou',
  in_progress: 'Em andamento',
};

export const DOCUMENT_SOURCE_LABELS: Record<string, string> = {
  whatsapp: 'WhatsApp',
  email: 'E-mail',
  registrar: 'Registrar',
  proposal: 'Cotação da IA',
};

export const DIRECTION_LABELS: Record<string, string> = {
  received: 'recebido',
  sent: 'enviado',
  internal: 'lido pelo Registrar',
};

const pad = (n: number) => String(n).padStart(2, '0');
const dayKey = (d: Date) => d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();

/** "hoje, 10:00", "amanhã, 10:00", "ontem, 16:40"; senão "dd/mm, HH:mm" (com ano quando é outro). Vazio para data ausente ou inválida. */
export function formatDossierWhen(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const day = (offset: number) => {
    const ref = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
    return dayKey(ref);
  };
  const key = dayKey(d);
  if (key === day(0)) return `hoje, ${time}`;
  if (key === day(1)) return `amanhã, ${time}`;
  if (key === day(-1)) return `ontem, ${time}`;
  const date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
  return d.getFullYear() === now.getFullYear() ? `${date}, ${time}` : `${date}/${d.getFullYear()}, ${time}`;
}

/** Abre o evento na agenda no dia certo: acrescenta `&date=YYYY-MM-DD` (data local) aos caminhos `/agenda`. */
export function agendaPath(openPath: string, at: string | null): string {
  if (!openPath.startsWith('/agenda') || !at) return openPath;
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return openPath;
  return `${openPath}&date=${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Movimentações só deste card; registro antigo sem card só vale quando o contato tem uma única oportunidade. */
export function logsForCard<T extends { cardId?: number | null }>(logs: T[], cardId: number, opportunityCount: number): T[] {
  return logs.filter((l) => l.cardId === cardId || (l.cardId == null && opportunityCount <= 1));
}

/** Próximo compromisso agendado desta oportunidade (não conta o do cliente, o passado nem o concluído). */
export function nextCardCommitment(items: DossierCommitment[], now: Date = new Date()): DossierCommitment | null {
  const candidates = items
    .filter((i) => i.scope === 'card' && i.state === 'scheduled' && i.at && new Date(i.at).getTime() >= now.getTime())
    .sort((a, b) => new Date(a.at as string).getTime() - new Date(b.at as string).getTime());
  return candidates[0] ?? null;
}
